import React, { useCallback } from 'react';
import { Button, Avatar } from '@framework-controls/core';
import css from './CalendarSelectBtn.module.scss';
import classNames from 'classnames';
import { ButtonIds } from '../CalendarSelect';
import { strings } from 'src/localization';
import NoProfile from 'src/content/icons/Profile2.svg';
import NoProfileWhite from 'src/content/icons/ProfileWhite.svg';

interface IProps {
    id: ButtonIds;
    label: string;
    icon: React.ReactElement;
    selected: boolean;
    theme: string;
    advisorURL: string;
    advisorName: string;
    onClick: (id: ButtonIds, e: any) => void;
}

const CalendarSelectBtn = (props: IProps) => {
    const btnClassName = classNames(
        css.calBtn,
        {
            [css.calBtnChecked]: props.selected,
            [css.calBtnCheckedCA]: props.theme === 'cadillac' && props.selected,
            [css.calBtnCadillac]: props.theme === 'cadillac',
        },
    );

    let contentsClassName = classNames(
        css.calBtnContents,
        {
            [css.calBtnContentsChecked]: props.selected,
        },
    );
    if (props.theme === 'colorSensitive') {
        contentsClassName = classNames(
            css.calBtnContentsCS,
            {
                [css.calBtnContentsCheckedCS]: props.selected,
            },
        );
    }

    const subBtnClassName = classNames(
        css.calSubBtn,
        {
            [css.calSubBtnChecked]: props.selected,
        },
    );

    const onClick = useCallback((e: any) => {
        props.onClick(props.id, e);
    }, [props.onClick, props.id]);

    /* checks to see if we are on the advisor tab. If so we take the advisor image
    URL and use it to make an Avatar component for the tab */
    let avatar = <Avatar/> || '';
    if (props.id === 'advSel') {
        let image = props.advisorURL;
        switch (image){
            case '':
            case undefined:
                image = NoProfile;
                break;
            default:
                break;
        }

        const AdvImgAltTag = props.advisorName + ' ' + strings.Photo;
        let avatarColor: 'default' | 'primary' | 'secondary' | 'contrast' | 'completed' | 'blank' = 'blank';
        if (props.theme === 'colorSensitive') {
            avatarColor = 'primary';
            image= NoProfileWhite;
        }
        if (!props.selected && props.theme === 'toyotaSPM') {
            avatarColor = 'contrast';
        }
        if (!props.advisorURL) {
            if (props.selected && props.theme === 'toyotaSPM') {
                avatarColor = 'primary';
                image= NoProfileWhite;
            }
        }
        if (props.selected && props.theme === 'cadillac') {
            image = NoProfileWhite;
        }
        avatar = <Avatar
            elevation={0}
            color={avatarColor}
            borderThickness={0}
            src={image}
            alt={AdvImgAltTag}
        />;
    }

    return (
        <div className={btnClassName}>
            <div className={subBtnClassName}>
                <Button
                    id={props.id + 'Btn'}
                    onClick={onClick}
                    variant={props.selected ? 'calBtnChecked' : 'calBtn'}
                    disableRipple
                    type={'text'}>
                    <div className={css.btnArea}>
                        <div className={css.contentsIconDiv}>
                            <div className={contentsClassName}>
                                <div className={css.avatar}>
                                    {props.id === 'advSel' ? avatar : props.icon}
                                </div>
                            </div>
                        </div>
                        <div className={css.contentsTitleDiv}>
                            <h3 className={contentsClassName}>{props.label}</h3>
                        </div>
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default CalendarSelectBtn;